import axios, { clearCsrfToken } from '../common/CommonConfigRestService'

const baseAuthUrl = '/auth'

export default {
  csrf () {
    return axios.get(baseAuthUrl + '/csrf').then(response => {
      clearCsrfToken()
      return response.data
    })
  },
  validate () {
    return this.csrf()
      .then(() => axios.get(baseAuthUrl + '/me'))
      .then(response => response.data)
  },
  login (userData) {
    return this.csrf()
      .then(() => axios.post(baseAuthUrl + '/login', {
        username: userData.username,
        password: userData.password
      }))
      .then(response => this.csrf().then(() => response.data))
  },
  logout () {
    return this.csrf()
      .then(() => axios.post(baseAuthUrl + '/logout'))
      .then(response => {
        clearCsrfToken()
        return response.data
      })
  }
}
